import axios from "axios";
import { baseUrl } from "./baseUrl";

const token = localStorage.getItem('token');

const api = axios.create({
    baseURL: `${baseUrl}/admin/user`,
    headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
    },
});

export const getUserReviews = async () => {
    try {
        const response = await api.get("/user-reviews-list");
        return response.data.reviews || [];
    } catch (error) {
        console.error("Error fetching user reviews:", error);
        throw error;
    }
}

export const updateReviewHomepageStatus = async (reviewId, showHomePage) => {
    try {
        const response = await api.post(`/user-reviews/update-status`, {
            reviewId: reviewId,
            status: showHomePage
        });
        return response.data;
    } catch (error) {
        console.error("Error updating review homepage status:", error);
        throw error;
    }
}

export const deleteUserReview = async (reviewId) => {
    try {
        const response = await api.delete(`/user-reviews/delete/${reviewId}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting user review:", error);
        throw error;
    }
}